import React from "react"

import Typography from "../../components/shared/Typography"
import { PracticeProvider } from "../../contexts/PracticeContext"
import DefaultProvider from "../../providers/DefaultProvider"

import ProReviewRequestsTable from "./ProReviewRequestsTable"

const Reviews = ({ clientRequests }) => (
  <>
    <div className="mb-8 flex items-center justify-between align-bottom sm:mb-4 sm:flex-col sm:items-start">
      <div className="flex flex-col">
        <Typography as="h1" variant="h3">
          Pending Reviews
        </Typography>
        <Typography variant="subtitle">
          {clientRequests?.length === 0 ? <>No pending reviews </> : <>{clientRequests.length} pending reviews</>}
        </Typography>
      </div>
    </div>

    <ProReviewRequestsTable clientRequests={clientRequests} />
  </>
)

export default function ProReviewsPendingPage(props) {
  return (
    <DefaultProvider>
      <PracticeProvider>
        <Reviews {...props} />
      </PracticeProvider>
    </DefaultProvider>
  )
}
